import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import AddToCartButton from "../../../../../components/Form/AddToCartButton/AddToCartButton";
import FormWrapper from "../../../../../components/Form/FormWrapper";
import PlusMinusInput from "../../../../../components/Form/PlusMinusInput/PlusMinusInput";
import { missingImageURL } from "../../../../../helpers/images";
import useAPI from "../../../../../hooks/useAPI";
import Sitemap from "../../../../../routes/sitemap";
import Box from "@mui/material/Box";
import scss from "./ProductListItem.module.scss";
import { toast } from "react-toastify";
import { Prices } from "../../../../../components/prices";
import { useTranslation } from "react-i18next";
import { isPurchaseAllowed } from "../../../../../helpers/product";

const ProductListItem = ({ product, translateKey }) => {
    const { t } = useTranslation();

    const api = useAPI();
    const navigate = useNavigate();
    // Track the quantity to add to the cart
    const [quantity, setQuantity] = useState(product?.behaviours?.cart?.default_loop_quantity ?? 1);

    const getQuantity = () => {
        if (quantity === 0) {
            setQuantity(product?.behaviours?.cart?.default_loop_quantity ?? 1);
            return product?.behaviours?.cart?.default_loop_quantity ?? 1;
        }
        return quantity;
    };

    const can_add_to_cart = product?.price?.price_defined && product?.inventory?.inventory_defined && product?.price?.price?.original > 0 && isPurchaseAllowed(product?.behaviours?.cart);

    const [loading, setLoading] = useState(false);
    const [isPlusMinusInputEmpty, setIsPlusMinusInputEmpty] = useState(false);

    return (
        <>
            <Box sx={{ display: "flex" }} className={`${scss.wrapper} ${scss.wrapperBoxMobile}`}>
                <Link tabIndex={-1} to={Sitemap.catalogue.productDetails + "/" + product?.id} className={scss.wrapperLink}>
                    {/* Image and name */}
                    <img className={scss.image} src={product?.images[0] ?? missingImageURL()} alt={product?.name} />
                    <img className={scss.imageHover} src={product?.images[0] ?? missingImageURL()} alt={product?.name} />
                    <span className={scss.name}>{product?.basic_data?.name}</span>
                    <span className={scss.code}>
                        <span className={scss.codeTitle}>{t(`${translateKey}-text-Code`)}:</span>
                        <span className={scss.codeInt}>{product?.basic_data?.sku}</span>
                    </span>
                </Link>
                <div className={scss.data}>
                    <div className={scss.price}>
                        <Prices price={product?.price} inventory={product?.inventory} behaviours={product?.behaviours?.cart} />{" "}
                    </div>
                    <FormWrapper
                        tabIndex={-1}
                        className={scss.addToCart}
                        onSubmit={() => {
                            if (!can_add_to_cart) return;
                            if (isPlusMinusInputEmpty) {
                                toast.warn(t(`${translateKey}-text-enter_quantity`));
                                setLoading(false);
                            } else {
                                api.globalAddToCart(product.basic_data?.id_product, getQuantity(), loading, setLoading);
                                setQuantity(1);
                            }
                        }}
                    >
                        {product?.product_type === "variant" ? (
                            <div
                                onClick={() => {
                                    navigate(Sitemap.catalogue.productDetails + "/" + product?.id);
                                }}
                                className={`text-center w-auto justify-content-center align-items-center d-flex ${scss.button1}`}
                            >
                                {t(`${translateKey}-button-product_link`)}
                            </div>
                        ) : (
                            <>
                                {can_add_to_cart ? (
                                    <>
                                        <div className={scss.plusminusinput}>
                                            <PlusMinusInput
                                                behaviours={product?.behaviours?.cart}
                                                max={+product?.inventory?.amount}
                                                quantity={quantity}
                                                setQuantity={setQuantity}
                                                setIsPlusMinusInputEmpty={setIsPlusMinusInputEmpty}
                                            />
                                        </div>

                                        <AddToCartButton
                                            translateKey={`${translateKey}-button`}
                                            iconOnly
                                            loading={loading}
                                            onClick={() => {
                                                if (isPlusMinusInputEmpty) {
                                                    toast.warn(t(`${translateKey}-text-enter_quantity`));
                                                    setLoading(false);
                                                } else {
                                                    api.globalAddToCart(product.basic_data?.id_product, getQuantity(), loading, setLoading);
                                                    setQuantity(1);
                                                }
                                            }}
                                            className={scss.addToCartButton}
                                            product={product}
                                        />
                                    </>
                                ) : (
                                    <div
                                        onClick={() => {
                                            navigate(`/kontakt?slug=${product?.slug}`);
                                        }}
                                        className={scss.upit}
                                    >
                                        {t(`${translateKey}-button-contact_link`)}
                                    </div>
                                )}
                            </>
                        )}
                    </FormWrapper>
                </div>
            </Box>
        </>
    );
};

export default ProductListItem;
